<template>
    <div class="text-base">

        <slot name="before-date"/>

        <h6 class="font-bold mb-4">Data</h6>

        <div class="vx-col sm:w-full">
            <span class="vx-col">Data inicial</span>
            <DatePicker format="dd/MM/yyyy" v-model="pickerDate.from"></DatePicker>
        </div>
        
        <div class="vx-col sm:w-full mt-2">
            <span class="vx-col">Data final</span>
            <DatePicker format="dd/MM/yyyy" v-model="pickerDate.to"></DatePicker>
        </div>

        <slot name="after-date"/>

    </div>
</template>

<script>
    import moment from 'moment';
    import DatePicker from './DatePicker.vue';
    var timeout = 0;

    export default {
        props: {
            dates: Object,
            skipRangeValidation: Boolean,
            throttleTime: Number,
        },
        components: {
            DatePicker
        },
        watch: {
            filters (val) {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.$emit('filter', val);
                }, this.throttleTime || 0);
            },
            dates: {
                handler (val) {
                    this.pickerDate = val;
                },
                deep: true
            },
            pickerDate: {
                handler (val) {
                    this.handleChange(val);
                },
                deep: true
            }
        },
        data() {
            return {
                date : {
                    from: moment().subtract(1, 'day').toDate(),
                    to: new Date()
                },
                pickerDate: {
                    from: moment().subtract(1, 'day').toDate(),
                    to: new Date()
                }
            }
        },
        computed: {
            filters () {
                // in case there is more filters, add in this computed
                const date = this.dateFilter;
                return { date };
            },
            from () { return moment(this.pickerDate.from); },
            to () { return moment(this.pickerDate.to); },
            dateFilter () {
                const date = {};
                if (this.to.isValid()) {
                    date.to = this.to.endOf('day').toDate();
                }
                if (this.from.isValid())
                    date.from = this.from.startOf('day').toDate();
                return (date.to || date.from) ? date : null
            },
            fromValidationError () { return (this.date.from &&  (!this.from.isValid() && 'Data inválida') || ((this.from.toDate() > (this.to && this.to.toDate())) && 'Data inicio deve ser inferior')) || '' },
            toValidationError () { return (this.date.to && !this.to.isValid() && 'Data inválida') || '' },
        },
        methods: {
            handleChange (val) {
                if (!val || !val.from || !val.to)
                    return;
                const isValidRange = this.skipRangeValidation || this.checkRange(val);
                if (!isValidRange) {
                    this.$nextTick(() => {
                        this.pickerDate = {
                            from: val.from,
                            to: moment(val.from).add(7, 'day').toDate(),
                        };
                    });
                    return;
                }
                if (val.from > val.to) {
                    this.$nextTick(() => {
                        this.pickerDate = {
                            from: val.to,
                            to: val.to,
                        };
                    });
                    return;
                }
                this.date.from = val.from;
                this.date.to = val.to;
            },
            checkRange (val) {
                var duration = moment.duration(moment(val.to).diff(val.from));
                const isValid = duration.asDays() <= 8;
                if (!isValid)
                    this.$warning({
                        zIndex: 99999,
                        title: 'Intervalo muito longo',
                        content: 'Intervalo de datas deve ser inferior a 1 (uma) semana. Um intervalo menor foi selecionado'
                    });
                return isValid;
            }
        },
        created () {
            this.$emit('filter', this.filters);
        }
    }
</script>

<style lang="scss" scoped>
 
  
</style>